'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$19() {
  this.b6c = null;
  this.b6d = false;
}
export { $c_Lpresto_LoginPageView$$anon$19 as $c_Lpresto_LoginPageView$$anon$19 };
$p = $c_Lpresto_LoginPageView$$anon$19.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$19;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$19() {
}
export { $h_Lpresto_LoginPageView$$anon$19 as $h_Lpresto_LoginPageView$$anon$19 };
$h_Lpresto_LoginPageView$$anon$19.prototype = $p;
$p.P = (function() {
  if ((!this.b6d)) {
    this.b6c = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.b6d = true;
  }
  return this.b6c;
});
var $d_Lpresto_LoginPageView$$anon$19 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$19, "presto.LoginPageView$$anon$19", ({
  Ma: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_LoginPageView$$anon$19 as $d_Lpresto_LoginPageView$$anon$19 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$19.js.map
